export default __webpack_public_path__ + "static/media/himank.4d9baf58.jpeg";